
(function(){
  // Quantity steppers
  document.addEventListener('click',function(e){
    var dec=e.target.closest('[data-qty-dec]'),inc=e.target.closest('[data-qty-inc]');
    if(dec||inc){var inp=(dec||inc).parentNode.querySelector('input');var v=parseInt(inp.value||'1',10);v=(dec?Math.max(1,v-1):v+1);inp.value=v;inp.dispatchEvent(new Event('change',{bubbles:true}));}
  });
  // Product variant + staffel
  var form=document.querySelector('[data-product-form]');
  if(form){
    var data=JSON.parse(document.getElementById('product-json').textContent);
    var idInput=form.querySelector('[name=id]');
    var qtyInput=form.querySelector('[name=quantity]');
    var nowEl=document.querySelector('[data-price-now]');
    var totalEl=document.querySelector('[data-total]');
    function money(c){return '€'+(c/100).toFixed(2).replace('.',',');}
    function selectVariant(vid){
      var v=data.variants.find(function(x){return x.id==vid;})||data.variants[0];
      idInput.value=v.id;
      if(nowEl)nowEl.textContent=money(v.price);
      document.querySelectorAll('[data-variant-btn]').forEach(function(b){b.classList.toggle('is-active',b.getAttribute('data-variant-btn')==String(v.id));});
      updateTotal();
    }
    function updateTotal(){
      var v=data.variants.find(function(x){return x.id==idInput.value;})||data.variants[0];
      var q=parseInt(qtyInput.value||'1',10);
      if(totalEl)totalEl.textContent=money(v.price*q);
    }
    document.querySelectorAll('[data-variant-btn]').forEach(function(b){
      b.addEventListener('click',function(){var vid=b.getAttribute('data-variant-btn');var st=b.getAttribute('data-set-qty');if(st)qtyInput.value=st;selectVariant(vid);});
    });
    if(qtyInput)qtyInput.addEventListener('change',updateTotal);
    selectVariant(idInput.value);
  }
  // Tabs
  document.querySelectorAll('[data-tab]').forEach(function(t){
    t.addEventListener('click',function(){
      var key=t.getAttribute('data-tab');
      document.querySelectorAll('[data-tab]').forEach(function(x){x.classList.toggle('is-active',x===t);});
      document.querySelectorAll('[data-tabpanel]').forEach(function(p){p.classList.toggle('is-hidden',p.getAttribute('data-tabpanel')!==key);});
    });
  });
  // Gallery
  document.querySelectorAll('[data-gallery-thumb]').forEach(function(th){
    th.addEventListener('click',function(){
      var src=th.getAttribute('data-src');var main=document.querySelector('[data-gallery-main]');
      if(main&&src)main.style.backgroundImage='url('+src+')';
      document.querySelectorAll('[data-gallery-thumb]').forEach(function(x){x.classList.toggle('is-active',x===th);});
    });
  });
  // Product recommendations (echte, passende Produkte via Shopify Recommendations API)
  var recBox=document.querySelector('[data-product-recs]');
  if(recBox){
    var rurl=recBox.getAttribute('data-url');
    var pid=recBox.getAttribute('data-product-id');
    fetch(rurl+'?section_id=product-recommendations&product_id='+pid+'&limit=4&intent=related')
      .then(function(r){return r.text();})
      .then(function(html){ if(html&&html.indexOf('pcard')>-1){ recBox.innerHTML=html; } })
      .catch(function(){});
  }
  // Mobile menu drawer
  var mOpen=document.querySelector('[data-menu-open]');
  var drawer=document.querySelector('[data-mdrawer]');
  if(mOpen&&drawer){
    function mClose(){drawer.removeAttribute('data-open');document.body.classList.remove('menu-open');}
    mOpen.addEventListener('click',function(){drawer.setAttribute('data-open','');document.body.classList.add('menu-open');});
    drawer.querySelectorAll('[data-menu-close]').forEach(function(b){b.addEventListener('click',mClose);});
    drawer.querySelectorAll('[data-acc]').forEach(function(t){
      t.addEventListener('click',function(){
        var item=t.closest('.mnav__item');var sub=item?item.querySelector('.mnav__sub'):null;
        if(!sub)return;
        if(t.hasAttribute('data-open')){t.removeAttribute('data-open');sub.setAttribute('hidden','');}
        else{t.setAttribute('data-open','');sub.removeAttribute('hidden');}
      });
    });
  }
  // Recover-password toggle (login page)
  document.addEventListener('click',function(e){
    var t=e.target.closest('[data-recover-toggle]');
    if(t){e.preventDefault();var box=document.querySelector('[data-recover]');if(box)box.classList.add('is-open');}
  });
  if(location.hash==='#recover'){var rb=document.querySelector('[data-recover]');if(rb)rb.classList.add('is-open');}
  // Address delete (Shopify expects a DELETE request)
  document.addEventListener('click',function(e){
    var del=e.target.closest('[data-method="delete"]');
    if(!del)return;
    e.preventDefault();
    var msg=del.getAttribute('data-confirm-delete')||'Wirklich löschen?';
    if(!window.confirm(msg))return;
    var f=document.createElement('form');
    f.method='post';f.action=del.getAttribute('href');f.style.display='none';
    f.innerHTML='<input type="hidden" name="_method" value="delete">';
    document.body.appendChild(f);f.submit();
  });
})();
